import { motion } from "framer-motion";
import { ArrowDownRight, Camera, ScrollText, Sparkles } from "lucide-react";

const PROMISES = [
  {
    id: "straight-quotes",
    icon: ScrollText,
    title: "Straight quotes",
    text: "The price Jason quotes is the price you pay. No hidden extras, no surprises on the invoice.",
  },
  {
    id: "photo-proof",
    icon: Camera,
    title: "Proof in photos",
    text: "Every job photographed before he starts and after he packs up — you see exactly what you paid for.",
  },
  {
    id: "tidy-site",
    icon: Sparkles,
    title: "Tidy site, every time",
    text: "Your place left cleaner than he found it — or the job's not done.",
  },
];

export default function Testimonials() {
  return (
    <section id="reviews" className="relative border-t border-white/[0.06] bg-[#0D1320] py-24 sm:py-32">
      <div
        className="pointer-events-none absolute right-[-10%] top-0 h-[26rem] w-[26rem] rounded-full bg-orange-500/10 blur-[140px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-16 grid gap-8 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-orange-400">04 — Our word</p>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
              New name.
              <br />
              Old-school standards.
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-slate-400 lg:col-span-5 lg:justify-self-end">
            Total Roof Care Taranaki is a new local business — so instead of showing you reviews, here's
            the standard every single job is held to.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3" data-testid="promises-grid">
          {PROMISES.map((p, i) => (
            <motion.div
              key={p.id}
              data-testid={`promise-card-${p.id}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="border border-white/[0.08] bg-[#131924] p-7 transition-[border-color,transform] duration-300 hover:-translate-y-1.5 hover:border-orange-500/40"
            >
              <span className="grid h-11 w-11 place-items-center border border-orange-500/40 text-orange-400">
                <p.icon className="h-5 w-5" strokeWidth={2} />
              </span>
              <h3 className="mt-6 font-heading text-lg font-semibold text-slate-100">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{p.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-12 flex flex-wrap items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-slate-500"
        >
          Just getting started —
          <a
            href="#quote"
            data-testid="first-customer-link"
            className="inline-flex items-center gap-2 border-b border-orange-500/40 pb-1 text-orange-400 transition-colors duration-200 hover:border-orange-400 hover:text-orange-300"
          >
            be one of our first customers
            <ArrowDownRight className="h-3.5 w-3.5" />
          </a>
        </motion.p>
      </div>
    </section>
  );
}
